/**
 * Monero address book entry model
 */
export default class MoneroAddressBookEntry {
    constructor(entry) {
        Object.assign(this, entry);
    }
    toJson() {
        return Object.assign({}, this);
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        this.index = index;
        return this;
    }
    getAddress() {
        return this.address;
    }
    setAddress(address) {
        this.address = address;
        return this;
    }
    getDescription() {
        return this.description;
    }
    setDescription(description) {
        this.description = description;
        return this;
    }
    getPaymentId() {
        return this.paymentId;
    }
    setPaymentId(paymentId) {
        this.paymentId = paymentId;
        return this;
    }
}
